import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CurrencyPipe } from '@frontend/sports/common/core/feature/money';
import { DsButtonIcon } from '@frontend/ui/button-icon';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { DynamicFontResizerComponent } from '../common/dynamic-font-resizer.component';
import { ShowInEpcotDirective } from '../common/epcot-config.directive';
import { IncrementalStakesComponent } from './incremental-stakes.component';
import { NumpadErrorComponent } from './numpad-error.component';
import { NumpadHostComponent } from './numpad-host.component';
import { NumpadKeysComponent } from './numpad-keys.component';
import { NumpadScrollDirective } from './numpad-scroll.directive';
import { NumpadComponent } from './numpad.component';
import { StakeFieldComponent } from './stake-field.component';
import { StakeFontResizerDirective } from './stake-font-resizer.directive';
import { StakeInputComponent } from './stake-input.component';
import { StakeWrapperComponent } from './stake-wrapper.component';
import { StakeComponent } from './stake.component';
import { ValidateStakeInputDirective } from './validate-stake-input.directive';

@NgModule({
    imports: [CommonModule, ShowInEpcotDirective, DynamicFontResizerComponent, IconCustomComponent, DsButtonIcon, CurrencyPipe],
    declarations: [
        IncrementalStakesComponent,
        NumpadKeysComponent,
        NumpadComponent,
        NumpadScrollDirective,
        StakeFontResizerDirective,
        StakeComponent,
        StakeFieldComponent,
        NumpadHostComponent,
        StakeInputComponent,
        ValidateStakeInputDirective,
        NumpadErrorComponent,
        StakeWrapperComponent,
    ],
    exports: [
        IncrementalStakesComponent,
        NumpadKeysComponent,
        NumpadComponent,
        StakeComponent,
        StakeFieldComponent,
        NumpadHostComponent,
        NumpadScrollDirective,
        StakeFontResizerDirective,
        StakeInputComponent,
        NumpadErrorComponent,
        StakeWrapperComponent,
    ],
})
export class NumpadModule {}
